export const SYSTEM_BUSY_EVENT = 'ptvn:system-busy';

export interface SystemBusyDetail {
  retryAfterSeconds?: number;
}

export const isSystemBusyResponse = (error: any): boolean => {
  const status = error?.response?.status ?? error?.status;
  const data = error?.response?.data ?? error?.data;
  return status === 503 && data?.code === 'SYSTEM_BUSY';
};

export const notifySystemBusy = (error: any): void => {
  if (!isSystemBusyResponse(error)) {
    return;
  }
  const data = error?.response?.data ?? error?.data;
  // Let the originating subscriber finish its error handling, then make the
  // capacity-specific modal authoritative over any generic error modal.
  window.setTimeout(() => window.dispatchEvent(new CustomEvent<SystemBusyDetail>(SYSTEM_BUSY_EVENT, {
    detail: { retryAfterSeconds: data?.retryAfterSeconds }
  })), 0);
};
